import { render, staticRenderFns } from "./Prepayment.vue?vue&type=template&id=48fbcb8a&scoped=true&"
import script from "./Prepayment.vue?vue&type=script&lang=js&"
export * from "./Prepayment.vue?vue&type=script&lang=js&"
import style0 from "./Prepayment.vue?vue&type=style&index=0&id=48fbcb8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbcb8a",
  null
  
)

export default component.exports